const normalizeTooltipParams = (params) =>
  Array.isArray(params) ? params : params ? [params] : [];

const getClickOffset = (event) => {
  const zrEvent = event?.event || event;
  const offsetX = Number(zrEvent?.offsetX);
  const offsetY = Number(zrEvent?.offsetY);
  return Number.isFinite(offsetX) && Number.isFinite(offsetY) ? [offsetX, offsetY] : null;
};

export const getClosestTooltipParam = (chartInstance, tooltipParams, event) => {
  const items = normalizeTooltipParams(tooltipParams).filter((item) => item?.seriesIndex != null);
  if (items.length <= 1) return items[0] ?? null;

  const clickOffset = getClickOffset(event);
  if (!clickOffset || typeof chartInstance?.convertToPixel !== 'function') return items[0];

  let closest = items[0];
  let closestDistance = Number.POSITIVE_INFINITY;

  items.forEach((item) => {
    const value = Array.isArray(item.value) ? item.value : null;
    const xValue = value?.[0] ?? item.axisValue;
    const yValue = value?.[1];
    if (xValue == null || yValue == null) return;

    try {
      const pixel = chartInstance.convertToPixel({ seriesIndex: item.seriesIndex }, [xValue, yValue]);
      if (!Array.isArray(pixel)) return;
      const distance = Math.hypot(pixel[0] - clickOffset[0], pixel[1] - clickOffset[1]);
      if (distance < closestDistance) {
        closest = item;
        closestDistance = distance;
      }
    } catch (e) {
      // Ignore conversion failures and keep the current closest item.
    }
  });

  return closest;
};

export const bindTooltipCanvasClick = (chartInstance, getTooltipParams, onSelect) => {
  const zrender = chartInstance?.getZr?.();
  if (!zrender || typeof zrender.on !== 'function') return null;

  const handleCanvasClick = (event) => {
    const tooltipParam = getClosestTooltipParam(chartInstance, getTooltipParams?.(), event);
    if (tooltipParam) onSelect?.(tooltipParam);
  };

  zrender.on('click', handleCanvasClick);
  return () => {
    if (typeof zrender.off === 'function') zrender.off('click', handleCanvasClick);
  };
};
